exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n/* hide the existing modal header\n */\n#work-item-detail-modal .modal-header * {\n  display: none;\n}\n", ""]);

